<template>
  <div class="orgTag-details app-container">
    <div class="global-header-wrap">
      <h3>
        {{ $t("org.tag") }}：<span>{{ $route.query.name }}</span>
      </h3>
      <button class="global-button-style" @click="$router.back()">
        {{ $t("commonMsg.back") }}
      </button>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="orgList-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchEvn" />
          </div>
          <div class="orgTag-details-btn">
            <button class="global-button-style" @click="addOrg">
              {{ $t("org.addOrg") }}
            </button>
            <button class="global-button-style">
              {{ $t("org.exportTag") }}
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <transition name="fade">
      <appendPopup
        v-if="appendPopup"
        :title="$t('org.addOrg')"
        @getSelection="getSelection"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import appendPopup from "@/components/appendPopup";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    appendPopup,
    listSearch,
    appTable,
    pagination
  },
  mixins: [listMixin],
  computed: {
    ...mapGetters(["appendPopup"]),
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("org.orgName")
        },
        {
          prop: "address",
          label: this.$t("org.area")
        },
        {
          prop: "fid",
          label: "FID"
        },
        {
          prop: "handle",
          label: this.$t("org.manage"),
          btn: [this.$t("commonMsg.del")]
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      params: {
        limit: 20,
        offset: 0,
        tag_id: this.$route.query.id
      },

      tableData: [],
      total: 0
    };
  },

  methods: {
    getList() {
      this.$http.getOrgList(this.params).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.count;
      });
    },

    del(data) {
      this.$http.tagDelOrg(this.$route.query.id, data.row.id).then(res => {
        this.tableData.splice(data.$index, 1);
      });
    },

    getSelection(selection) {
      this.$http
        .tagAddOrg(this.$route.query.id, { orgIds: selection.ids })
        .then(res => {
          this.getList();
          this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        });
    },

    addOrg() {
      this.$store.dispatch(
        "hasData",
        this.tableData.map(item => item.id)
      );
      this.$store.commit("windowHandle", "appendPopup");
    }
  }
};
</script>

<style lang="scss" scoped>
.orgTag-details-header {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    // margin-right:10px;
  }
}
.orgTag-details-pagination {
  padding: 10px;
  text-align: right;
}
</style>
